import { type FC, useState } from 'react';
import {
  ColumnDef,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  type PaginationState,
  type SortingState,
  useReactTable,
} from '@tanstack/react-table';

import type { ClusterByIdQueryResult } from '@/api/generated';
import {
  type DescribeImageModelRun,
  type ExtractStructureModelRun,
  type GenerateAudioModelRun,
  type TextTranslationModelRun,
} from '@/api/generated.schemas';
import { DataTable } from '@/components/blocks/data-table/data-table';

type ModelRun =
  | TextTranslationModelRun
  | GenerateAudioModelRun
  | DescribeImageModelRun
  | ExtractStructureModelRun;

interface ModelRunsProps {
  data: ClusterByIdQueryResult;
  columns: Array<ColumnDef<ModelRun>>;
}

const ModelRuns: FC<ModelRunsProps> = ({ data, columns }) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [sorting, setSorting] = useState<SortingState>([]);

  const table = useReactTable<ModelRun>({
    state: {
      pagination,
      sorting,
    },
    getRowId: (row) => row.id,
    data: data.data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onPaginationChange: setPagination,
    pageCount: Math.ceil(data.data.length / pagination.pageSize),
    getSortedRowModel: getSortedRowModel(),
    onSortingChange: setSorting,
  });

  return <DataTable table={table} />;
};

export default ModelRuns;
